import React from 'react'

import useLocationSearch from '@shared/innmaxLib/hooks/useLocationSearch'
import { useLazyQueryDevice, useQueryMultipleDevice } from '@services/device'
import { DeviceTypeId } from '@services/constants/devices'
import { useSessionTree } from '@services/session'

export const useUrlSeach = ({
  searchDeviceOnSuccess,
  searchDevicesOnSuccess,
  searchSessionOnSuccess,
}: any) => {
  const {
    device: searchDevice,     //指定單個device
    devices: searchDevices,   //指定多個device
    session: searchSession,   //指定區域
  } = useLocationSearch()

  const { byId } = useSessionTree()

  const { fetchMultipleDevice } = useQueryMultipleDevice()

  const { queryDevice } = useLazyQueryDevice({
    onSuccess: (data: any) => searchDeviceOnSuccess(
      byId[data?.sessionId],
      {
        ...data,
        ...(data?.parentDeviceSeq && {
          displayName: data.parentDeviceDisplayName,
          deviceType: data.parentDeviceType,
          id: data?.parentDeviceSeq,
        }),
        direct: {
          deviceType: data.deviceType,
          id: data.id,
        },
      },
    )
  })

  React.useEffect(() => {
    if (searchDevice && byId) {
      const query = searchDevice.split(',')
      const isValid = (
        query.length === 2 &&
        DeviceTypeId[query[0]] &&
        parseInt(query[1])
      ) ? true : false
      if (isValid) {
        queryDevice({ deviceType: DeviceTypeId[query[0]], id: query[1] })
      }
    }
  }, [searchDevice, byId])  //eslint-disable-line

  React.useEffect(() => {
    if (searchDevices && byId) {
      const queries = searchDevices.split(',')
      .filter((d: string) => DeviceTypeId[d.split('-')[0]] && parseInt(d.split('-')[1]))
      .map((d: string) => {
        const [deviceType, id] = d.split('-')
        return { deviceType: DeviceTypeId[deviceType], id }
      })
      if (queries.length) {
        fetchMultipleDevice(queries).then(res => {
          searchDevicesOnSuccess(
            res.map(data => ({
              ...data,
              ...(data?.parentDeviceSeq && {
                displayName: data.parentDeviceDisplayName,
                deviceType: data.parentDeviceType,
                id: data?.parentDeviceSeq,
              }),
              direct: {
                deviceType: data.deviceType,
                id: data.id,
              },
            }))
          )
        })
      }
    }
  }, [searchDevices, byId]) //eslint-disable-line

  React.useEffect(() => {
    if (searchSession && byId) {
      searchSessionOnSuccess(byId[searchSession])
    }
  }, [searchSession, byId]) //eslint-disable-line

  return {
    searchDevice,
    searchDevices,
    searchSession
  }

}